import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Option, CheckTypes, Check } from '../../../../../classes';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  AuthService,
  ReplyService,
  TransactionService
} from '../../../../../services';
import { AngularFireDatabase } from '@angular/fire/database';
import { map, startWith, tap, debounce, debounceTime } from 'rxjs/operators';
import { get, orderBy } from 'lodash';

@Component({
  template: ''
})
export class OptionComponent implements OnInit {
  @Input() option: Option;
  @Input() optionsFormGroup: FormGroup;

  subscriptions: Subscription[] = [];
  optionId: string;
  as: string;

  filled_up_to: number = 0;
  filled: boolean = true;
  checkStatus: CheckTypes;
  checkPlace:number;
  checkOrder:number = -1;
  get checked(): boolean {
    return ['reserved', 'confirmed', 'static'].includes(this.checkStatus);
  }
  get disabled(): boolean {
    // disactivated state
    return (
      typeof this.option.quota === 'number' &&
      (this.option.quota === 0 ||
        (this.filled &&
          ![
            'reserved',
            'confirmed',
            'static',
            'confirmed-to-be-canceled'
          ].includes(this.checkStatus)))
    );
  }
  get toggling(): boolean {
    return ['reserving', 'unreserving'].includes(this.checkStatus);
  }
  constructor(
    protected reply: ReplyService,
    protected auth: AuthService,
    protected transaction: TransactionService,
    protected db: AngularFireDatabase,
    protected cdRef: ChangeDetectorRef
  ) {
    this.as = this.auth.as;
  }
  ngOnInit() {
    this.refreshFilled(this.option.quota, 0);

    // watch replyTracker
    const optionLevelTracker = this.reply.tracker.getChildTracker([
      this.as,
      this.option.question.id,
      this.option.id
    ]);
    this.subscriptions.push(
      optionLevelTracker.onContentUpdate.pipe(
        startWith(null),
        debounceTime(0),
      ).subscribe(() => {
        this.refreshCheckStatus();
      })
    );
    const quesionLevelTracker = this.reply.tracker.getChildTracker([
      this.as,
      this.option.question.id,
    ]);
    this.subscriptions.push(
      quesionLevelTracker.onContentUpdate.pipe(
        startWith(null),
        debounceTime(0),
      ).subscribe(()=> {
        this.refreshCheckOrder();
      })
    )

    // watch fb.filled_up_to
    if (typeof this.option.quota === 'number' && this.option.quota > 0) {
      this.subscriptions.push(
        this.db
          .object(this.transaction.getAgainstQuotaRef(this.option))
          .valueChanges()
          .pipe(map(v => (v ? v : 0)))
          .subscribe((filled_up_to: number) => {
            this.filled_up_to = filled_up_to;
            this.refreshFilled(this.option.quota, filled_up_to);
          })
      );
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  refreshFilled(quota: number, filled_up_to: number) {
    if (typeof quota === 'number' && quota > 0) {
      this.filled = filled_up_to >= quota;
    } else {
      this.filled = false;
    }
    this.cdRef.detectChanges();
  }

  refreshCheckStatus() {
    const check = this.reply.getCheck(this.option, this.as);
    const checkStatus:CheckTypes = get(check, 'type');
    const checkPlace:number = get(check, 'place');
    if (this.checkStatus !== checkStatus) this.checkStatus = checkStatus;
    if (this.checkPlace !== checkPlace) this.checkPlace  = checkPlace;
    this.cdRef.detectChanges();
  }
  refreshCheckOrder () {
    const check = this.reply.getCheck(this.option, this.as);
    if (!check && this.checkOrder === -1) return;
    const checkOrder:number = this.option.question.options.map(option=>get(this.reply.getCheck(option, this.as), 'timestamp')).filter(v=>v).sort().indexOf(get(check, 'timestamp'));
    if (this.checkOrder !== checkOrder) this.checkOrder = checkOrder;
    this.cdRef.detectChanges();
  }  
  toggleCheck(): void {
    if (this.option.question.survey.open_at > Date.now())
      return alert('ì¤ë¬¸ì´ ìì§ ììëì§ ìììµëë¤.');
    if (this.option.question.survey.close_at < Date.now())
      return alert('ì´ë¯¸ ë§ê°ë ì¤ë¬¸ìëë¤.');
    if (this.disabled) return alert('ìë¦¬ê° ììµëë¤.');
    if (this.checkStatus && this.checkStatus.match('ing')) return;
    const checking = !this.checked;
    this.reply.toggle(this.option, checking ? true : null);
  }

  refreshView() {
    this.cdRef.detectChanges();
  }
}
